function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import Modal from 'react-modal';
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T, useTranslate } from 'shared/helper/translate';
import './order-certificate.scss';

// import CertificateForm from './CertificateForm';

var OrderCertificate = function OrderCertificate(_ref) {
  var addMessage = _ref.addMessage,
    order = _ref.order,
    saving = _ref.saving,
    updateCertificate = _ref.updateCertificate;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formDisplayed = _useState2[0],
    setFormDisplayed = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    certificateFormData = _useState4[0],
    setCertificateFormData = _useState4[1];
  var editCertificate = function editCertificate() {
    setFormDisplayed(true);
  };
  var viewCertificate = function viewCertificate(certificate) {
    // We have to have authors do download a certificate
    if (certificate.authors.length === 0) {
      addMessage({
        message: 'Please include the title and author(s) that you would like displayed on your certificate.',
        type: 'error'
      });
      editCertificate();
    } else {
      window.location.assign("/api/certificate/".concat(certificate.code, "/pdf"));
    }
  };
  var handleUpdateCertificate = function handleUpdateCertificate(certificateCode, externalId, data) {
    updateCertificate(certificateCode, externalId, data).then(function (_ref2) {
      var error = _ref2.error,
        certificate = _ref2.certificate;
      setFormDisplayed(false);
      if (!error) {
        viewCertificate(certificate);
      }
    });
  };
  if (!order.certificateReady || !order.certificate) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('View Certificate'),
    type: "button",
    className: "action-link view-certificate text-uppercase d-block button-as-link",
    onClick: function onClick() {
      return viewCertificate(order.certificate);
    },
    title: t('Download certificate')
  }, /*#__PURE__*/React.createElement(T, {
    source: "View Certificate"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Edit Certificate'),
    type: "button",
    className: "action-link modify-certificate text-uppercase d-block button-as-link",
    onClick: editCertificate
  }, /*#__PURE__*/React.createElement(T, {
    source: "Edit Certificate"
  })), /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: formDisplayed,
    overlayClassName: "react-modal-overlay",
    className: "react-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reedit-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "react-modal-title"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Modify Certificate"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content"
  }))));
};
export default OrderCertificate;